import { HtmlEntities } from '@wf-sl/common-utilities'

import { isValidISO8601 } from '../validator/is-valid-iso-8601'
import { formatDateWithSeconds } from './format-date-with-seconds'
import { formatIso8601String } from './format-iso-8601-string'

/**
 * Depending on the account setting 'ShowDateTimeWithSeconds', it will return a formatted date with or without seconds.
 * If null is passed an MDASH is returned.
 *
 * @param {string} date - String datetime. Must be ISO-8601 compliant
 * @param {Intl} intl - Global modux intl helper
 * @param {boolean} showDateTimeWithSeconds - Should date be formatted with seconds? Defaults to false.
 * @return {string} Returns a string with the formatted date, time and seconds or an MDASH
 */
export const getDateTimeFormattedSeconds = (date, intl, showDateTimeWithSeconds = false) => {
    if (intl && isValidISO8601(date)) {
        return showDateTimeWithSeconds
            ? formatDateWithSeconds(intl, date)
            : formatIso8601String(intl, date, false, true)
    }

    return HtmlEntities.MDASH
}
